/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaLegge } from '@models';

@Pipe({
    name: 'anagraficaLegge',
})
export class AnagraficaLeggePipe implements PipeTransform {

    transform(value: number, items: AnagraficaLegge[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
